import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_CONTACT_TYPE_VISIBLE } from "../util/floorContacts";

const chartSlice = createSlice({
  name: "chart",
  initialState: {
    list_metrics: [
      "hip_right_flex", "hip_left_flex","shoulder_right_flex", "shoulder_left_flex",
    ],
    list_sensor_metrics: [],
    contactGlobalVisible: true,
    contactTypeVisible: { ...DEFAULT_CONTACT_TYPE_VISIBLE },
    contactSourceVisible: { pipeline: true, user: true },
    contactChartVisible: {},
  },
  reducers: {
    updateListMetrics: (state, action) => {
      state.list_metrics = [...new Set(action.payload)];
    },
    updateListSensorMetrics: (state, action) => {
      state.list_sensor_metrics = [...new Set(action.payload)];
    },
    updateBothLists: (state, action) => {
      state.list_metrics = [...new Set(action.payload.list_metrics)];
      state.list_sensor_metrics = [...new Set(action.payload.list_sensor_metrics)];
    },
    setContactGlobalVisible: (state, action) => {
      state.contactGlobalVisible = !!action.payload;
    },
    setContactTypeVisible: (state, action) => {
      const { typeKey, visible } = action.payload || {};
      if (!typeKey) return;
      state.contactTypeVisible = {
        ...state.contactTypeVisible,
        [typeKey]: !!visible,
      };
    },
    setContactSourceVisible: (state, action) => {
      const { source, visible } = action.payload || {};
      if (source !== 'pipeline' && source !== 'user') return;
      state.contactSourceVisible = {
        ...state.contactSourceVisible,
        [source]: !!visible,
      };
    },
    setContactChartVisible: (state, action) => {
      const { chartKey, visible } = action.payload || {};
      if (!chartKey) return;
      state.contactChartVisible = {
        ...state.contactChartVisible,
        [chartKey]: !!visible,
      };
    },
  },
});
export const chartActions = chartSlice.actions;
export default chartSlice;
